export const AGE_RATING_CONFIG = {
    '0+': {
        'en-US': { label: 'E', backgroundColor: '#FFFFFF', textColor: '#000000' },
        'de-DE': { label: '0', backgroundColor: '#FFFFFF', textColor: '#000000' },
        'fr-FR': { label: '3', backgroundColor: '#8CC63F', textColor: '#FFFFFF' },
        'it-IT': { label: '3', backgroundColor: '#8CC63F', textColor: '#FFFFFF' },
        'es-ES': { label: '3', backgroundColor: '#8CC63F', textColor: '#FFFFFF' },
        'pl-PL': { label: '3', backgroundColor: '#8CC63F', textColor: '#FFFFFF' },
        'pt-BR': { label: 'L', backgroundColor: '#00A550', textColor: '#FFFFFF' },
        'tr-TR': { label: '3+', backgroundColor: '#8CC63F', textColor: '#FFFFFF' },
        'id-ID': { label: '3+', backgroundColor: '#8CC63F', textColor: '#FFFFFF' },
    },
    '6+': {
        'en-US': { label: 'E10+', backgroundColor: '#FFFFFF', textColor: '#000000' },
        'de-DE': { label: '6', backgroundColor: '#F7D937', textColor: '#000000' },
        'fr-FR': { label: '7', backgroundColor: '#8CC63F', textColor: '#FFFFFF' },
        'it-IT': { label: '7', backgroundColor: '#8CC63F', textColor: '#FFFFFF' },
        'es-ES': { label: '7', backgroundColor: '#8CC63F', textColor: '#FFFFFF' },
        'pl-PL': { label: '7', backgroundColor: '#8CC63F', textColor: '#FFFFFF' },
        'pt-BR': { label: '10', backgroundColor: '#0095DA', textColor: '#FFFFFF' },
        'tr-TR': { label: '7+', backgroundColor: '#8CC63F', textColor: '#FFFFFF' },
        'id-ID': { label: '7+', backgroundColor: '#8CC63F', textColor: '#FFFFFF' },
    },
    '12+': {
        'en-US': { label: 'T', backgroundColor: '#FFFFFF', textColor: '#000000' },
        'de-DE': { label: '12', backgroundColor: '#6CA03D', textColor: '#FFFFFF' },
        'fr-FR': { label: '12', backgroundColor: '#F89828', textColor: '#FFFFFF' },
        'it-IT': { label: '12', backgroundColor: '#F89828', textColor: '#FFFFFF' },
        'es-ES': { label: '12', backgroundColor: '#F89828', textColor: '#FFFFFF' },
        'pl-PL': { label: '12', backgroundColor: '#F89828', textColor: '#FFFFFF' },
        'pt-BR': { label: '12', backgroundColor: '#FFD100', textColor: '#000000' },
        'tr-TR': { label: '12+', backgroundColor: '#F89828', textColor: '#FFFFFF' },
        'id-ID': { label: '12+', backgroundColor: '#F89828', textColor: '#FFFFFF' },
    },
    '16+': {
        'en-US': { label: 'M', backgroundColor: '#FFFFFF', textColor: '#000000' },
        'de-DE': { label: '16', backgroundColor: '#006AB3', textColor: '#FFFFFF' },
        'fr-FR': { label: '16', backgroundColor: '#F89828', textColor: '#FFFFFF' },
        'it-IT': { label: '16', backgroundColor: '#F89828', textColor: '#FFFFFF' },
        'es-ES': { label: '16', backgroundColor: '#F89828', textColor: '#FFFFFF' },
        'pl-PL': { label: '16', backgroundColor: '#F89828', textColor: '#FFFFFF' },
        'pt-BR': { label: '16', backgroundColor: '#ED1C24', textColor: '#FFFFFF' },
        'tr-TR': { label: '16+', backgroundColor: '#F89828', textColor: '#FFFFFF' },
        'id-ID': { label: '16+', backgroundColor: '#F89828', textColor: '#FFFFFF' },
    },
    '18+': {
        'en-US': { label: 'M', backgroundColor: '#FFFFFF', textColor: '#000000' },
        'de-DE': { label: '18', backgroundColor: '#DA291C', textColor: '#FFFFFF' },
        'fr-FR': { label: '18', backgroundColor: '#E30613', textColor: '#FFFFFF' },
        'it-IT': { label: '18', backgroundColor: '#E30613', textColor: '#FFFFFF' },
        'es-ES': { label: '18', backgroundColor: '#E30613', textColor: '#FFFFFF' },
        'pl-PL': { label: '18', backgroundColor: '#E30613', textColor: '#FFFFFF' },
        'pt-BR': { label: '18', backgroundColor: '#000000', textColor: '#FFFFFF' },
        'tr-TR': { label: '18+', backgroundColor: '#E30613', textColor: '#FFFFFF' },
        'id-ID': { label: '18+', backgroundColor: '#E30613', textColor: '#FFFFFF' },
    },
}
